import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {AccessJson} from '@amlCore/models';
import {RegistriesService} from '../../service';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {AlertPanelComponent, AlertPanelService, AlertService} from '@amlCore/components';
import {Utils} from '@amlCore/utils';
import {IDataResponse} from '@amlCore/interfaces';
import {
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';
import {UnwantedInfoList} from "../../model/unwantedInfoList.model";
import {DictImportResult} from "../../model/dictImportResult.model";
import {AlertModalComponent, InputFileComponent} from "../../../core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-registry-unwanted-info-list',
  templateUrl: './unwantedInfoList.component.html'
})
export class UnwantedInfoListComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              private readonly userSrv: UserService,
              protected readonly alertPanelSrv: AlertPanelService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              private readonly alertSrv: AlertService,
              protected readonly tableService: TableService,
              protected readonly router: Router,
              private modalService: NgbModal) {
    super(router, activatedRoute, visitedService, tableService, {
      sort: 'sysRegDate',
      dir: 'DESC'
    });
  }

  dataList: Array<UnwantedInfoList> = [];
  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_UNWANTED);
    this.activatedRoute.queryParams.subscribe((data) => {
      this.loadList(this.syncParams(data));
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  // @override
  public onSearch() {
    this.customSearch();
  }

  // @override
  public onFilter() {
    this.customSearch();
  }

  public showSubjList(item: UnwantedInfoList) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/unwantedList', item.id]);
  }

  public remove($event, item: UnwantedInfoList) {
    this.alertSrv.clear();
    this.regSrv.deleteFile(`/api/v1/qref/unwanted/remove/info/${item.id}`).subscribe(() => {
      this.alertSrv.success(`Запись ${item.fileName} удалена!`);
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  public checkRiskFactor(item: UnwantedInfoList) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.UNWANTED, this.loadCheckList, this.alertObjToCheck);
  }

  private customSearch() {
    const params = this.getSearchPage(this.filter);
    params['sort'] = 'number';
    params['dir'] = 'ASC';
    const urlParam = {};
    for (const key in params) {
      if (params[key] || typeof params[key] === "number") {
        urlParam[key] = params[key];
      }
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigateByUrl('registries/unwantedList?q=' + Utils.encodeJSONBase64(urlParam));
  }

  //обработка результата импорта
  public onAfterImport(data: DictImportResult) {
    if(!data?.success){
      const modal = this.modalService.open(AlertModalComponent);
      modal.componentInstance.text = data.error;
    }
    this.loadList();
  }


  public loadList(params?: UnwantedInfoList) {
    const queryParams = this.getParams(params);
    this.regSrv.getUnwantedInfoList(queryParams).subscribe((data: IDataResponse<UnwantedInfoList>) => {
      this.initIdsMap(data);
      this.dataList = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }
}
